import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type {
    GetAdminBusinessInsightsOverviewResponse,
    UseGetAdminBusinessInsightsOverviewParams,
    UseGetAdminBusinessInsightsOverviewResult,
} from './types';

const useGetAdminBusinessInsightsOverview = ({
    enabled,
}: UseGetAdminBusinessInsightsOverviewParams): UseGetAdminBusinessInsightsOverviewResult => {
    const { data, isLoading, error, refetch } =
        useHttpQuery<GetAdminBusinessInsightsOverviewResponse>({
            pathname: '/admin/business-insights/overview',
            method: 'GET',
            key: ['admin-business-insights-overview'],
            queryOptions: {
                enabled,
            },
        });

    return {
        overview: data?.data ?? null,
        isLoadingOverview: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useGetAdminBusinessInsightsOverview;
